import { fetch } from "@/api/fetch-auto-refresh";
import { useStore } from "@/store";
const apiURL = process.env.VUE_APP_API_URL;

const getEventSettings = async () => {
  const requestOptions = {
    method: "GET"
  };

  const response = await fetch(`${apiURL}/v1/event-settings/`, requestOptions);
  if (!response.ok) throw new Error("Unable to load event settings.");
  const data = await response.json();
  return data;
};

const updateEventSettings = async eventSettings => {
  const store = useStore();
  let authToken = store.state.auth.token;
  //Remove some properties
  delete eventSettings.createdAt;
  delete eventSettings.updatedAt;
  delete eventSettings.id;

  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + authToken
    },
    body: JSON.stringify(eventSettings)
  };

  const response = await fetch(`${apiURL}/v1/event-settings/`, requestOptions);
  const data = await response.json();
  return data;
};

const teamResetRequest = async (path = "", body) => {
  const store = useStore();
  const response = await fetch(
    `${apiURL}/v1/event-settings/team-reset${path}`,
    {
      method: body ? "POST" : "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + store.state.auth.token
      },
      ...(body ? { body: JSON.stringify(body) } : {})
    }
  ).catch(error => {
    throw new Error(
      (error.body && error.body.message) ||
        error.message ||
        "Unable to load or start the team reset."
    );
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Unable to load or start the team reset.");
  }
  return data;
};

const getTeamResetStatus = () => teamResetRequest();
const startTeamReset = body => teamResetRequest("", body);
const resumeTeamReset = body => teamResetRequest("/resume", body);

export {
  getEventSettings,
  updateEventSettings,
  getTeamResetStatus,
  startTeamReset,
  resumeTeamReset
};
